import _ from 'lodash'

import { UserRole } from '..'
import { UserGroup, userGroupRoles } from '../types/UserGroupRoles'

export const authorizeGroupRole = (userGroup: UserGroup, userRole: UserRole) =>
  _.includes(userGroupRoles[userGroup], userRole)
